export default __webpack_public_path__ + "static/media/error-icon.aed0a2ca.svg";